module.exports = __webpack_public_path__ + "img/pay-welfare-bg.4481142a.png";